import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { STANDALONE_APP_CONFIGURATION, StandaloneAppConfiguration } from '@ftr/api-shared'
import { AppName, AppPlatform } from '@ftr/contracts/api/standalone-apps'
import { SimpleWindowRefService } from '@ftr/foundation'
import { AppPaths } from '@ftr/routing-paths'

@Injectable({
  providedIn: 'root',
})
export class AppDownloadService {
  private readonly router = inject(Router)
  private readonly windowRefService = inject(SimpleWindowRefService)
  readonly appConfig = inject<StandaloneAppConfiguration>(STANDALONE_APP_CONFIGURATION)

  getStandaloneAppLink(): string {
    return this.router.serializeUrl(this.router.createUrlTree([AppPaths.StandaloneAppDownload]))
  }

  getDownloadUrl(appName: AppName, platform: AppPlatform): string {
    return `${this.appConfig.appDownloadUrl}${appName}?platform=${platform}`
  }

  openDownloadUrl(downloadUrl: string): void {
    this.windowRefService.open(downloadUrl, '_blank')
  }
}
